import React from "react"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import * as module2Style from "../styles.module.scss"

const getImageFooterDescription = type => {
  switch (type[0].nodeType) {
    case "list-item":
      let getListItems = type.map((listItem, idx) => (
        <p key={idx} className={module2Style.moduleImageFooterDescription}>
          {listItem.content[0].content[0].value}
        </p>
      ))
      return getListItems

    case "text":
      return (
        <p className={module2Style.moduleImageFooterDescription}>
          {type[0].value}
        </p>
      )
    default:
      return <></>
  }
}

const ModuleType2 = ({ mod, data }) => {
  return (
    <div className={`${module2Style.module2}`}>
      <div className={module2Style.moduleTextBlock}>
        <div className={module2Style.moduleName}>
          <h2 className={module2Style.moduleTag}>{data.title}</h2>
          <ul className={module2Style.moduleBullets}>
            {data.bulletPoints[0].bullets.map((item, idx) => (
              <li className={module2Style.moduleList} key={idx}>
                <p className={module2Style.listItem}>{item}</p>
              </li>
            ))}
          </ul>
        </div>
        <p className={module2Style.moduleDescription}>
          {data.description.description}
        </p>
      </div>
      <div className={module2Style.moduleImageContainer}>
        {data.images &&
          data.images.map((item, idx) => {
            const image = getImage(item.image)
            return (
              <div className={module2Style.moduleImage} key={idx}>
                <GatsbyImage
                  style={{
                    maxWidth: `${item.image.file.details.image.width}px`,
                    height: "auto",
                    margin: "0 auto",
                  }}
                  key={item.image.id}
                  alt={item.image.title}
                  image={image}
                />
                {item.dynamicText && (
                  <div className={module2Style.moduleImageFooter}>
                    <p className={module2Style.moduleImageFooterTitle}>
                      {item.title}
                    </p>
                    {getImageFooterDescription(
                      item.dynamicText.content[0].content
                    )}
                  </div>
                )}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default ModuleType2
